import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'usaPhoneNo' })
export class UsaPhoneNoPipe implements PipeTransform {
  transform(value: string, args?: string | string[]): string {
    if (!value || isNaN(+value)) {
      return '';
    }

    if (typeof args === 'string') {
      args = [args];
    }

    if (((args || []) as string[]).indexOf('noPrefix') > -1) {
      return value
        .replace(/\D/g, '')
        .substring(1, 11)
        .replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }

    return value
      .replace(/\D/g, '')
      .substring(0, 11)
      .replace(/^(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/, '+$1 ($2) $3-$4');
  }
}
